module.exports = __webpack_public_path__ + "img/logo公司简介.9705fea2.png";